import { render, staticRenderFns } from "./DocumentConfigTable.vue?vue&type=template&id=4e3c07da&"
import script from "./DocumentConfigTable.vue?vue&type=script&lang=js&"
export * from "./DocumentConfigTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports